const orders = {
  methods: {
    getOrder (id) {
      let orders = this.get_data.orders || []
      return orders.find(o => o.id === id) || false
    },
    getClasses (item) {
      var theme = (this.$vuetify.theme.dark ? 'darken' : 'lighten')
      var return_ = 'order-row '
      return_ += `${(this.getStatus(item.status).class || `grey ${theme}-2`)} `
      return_ += (item.read ? 'read' : 'unread')
      return return_
    },
    getType (type) {
      return (this.get_global.defaults.options.orders.types && typeof this.get_global.defaults.options.orders.types[type - 1] !== 'undefined' ? this.get_global.defaults.options.orders.types[type - 1] : {})
    },
    getStatus (status) {
      return (this.get_global.defaults.options.orders.status && typeof this.get_global.defaults.options.orders.status[status - 1] !== 'undefined' ? this.get_global.defaults.options.orders.status[status - 1] : {})
    },
    getPaid (order) {
      if (order)
        switch (true) {
          case (order.status === 8 || (typeof order.deleted !== 'undefined' && order.deleted === 1)):
            return this.get_global.defaults.options.orders.status[7]
          case (order.total_paid === 0):
            return this.get_global.defaults.options.orders.payment.status[0]
          case (order.total_paid > 0 && order.total_paid < order.total):
            return this.get_global.defaults.options.orders.payment.status[1]
          case (order.total_paid > 0 && order.total_paid >= order.total):
            return this.get_global.defaults.options.orders.payment.status[2]
        }
      return {}
      // return (this.get_global.defaults.options.orders.payment.status && typeof this.get_global.defaults.options.orders.payment.status[paid] !== 'undefined' ? this.get_global.defaults.options.orders.payment.status[paid] : '')
    },
    getHistory (type) {
      return (this.get_global.defaults.options.orders.history && typeof this.get_global.defaults.options.orders.history[type - 1] !== 'undefined' ? this.get_global.defaults.options.orders.history[type - 1] : {})
    },

    cancel (order) {
      if (!order.canceled) {
        this.$store.dispatch('setOverlay', true)
        this.$dialog.confirm({
          text: this.lang.orders.dialog.cancel(order.id),
          title: this.lang.confirm.title,
          waitForResult: true
        }).then(res => {
          this.$store.dispatch('setOverlay', false)
          if (res) {
            this.$store.dispatch('saveAction', { page: 1, type: 2, item: order.id })
            order.status = 6
            this.$emit('input', order)
          }
        })
      }
    },
    remove (order) {
      this.$store.dispatch('setOverlay', true)
      this.$dialog.confirm({
        text: this.lang.orders.dialog.delete(order.id),
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) {
          this.$store.dispatch('saveAction', { page: 1, type: 1, item: order.id })
          const obj = (this.get_data.orders ? this.get_data.orders.find(el => el.id === order.id) : {})
          const index = this.get_data.orders.indexOf(obj)
          if (index >= 0) this.get_data.orders.splice(index, 1)
        }
      })
    },

    updateOrderRow (order) {
      const obj = (this.get_data.orders ? this.get_data.orders.find(el => el.id === order.id) : {})
      const index = this.get_data.orders.indexOf(obj)
      if (index >= 0 && typeof this.get_data.orders[index] !== 'undefined') this.get_data.orders[index] = { ...order }
    },

    readMark (order) {
      if (!order.read) this.$store.dispatch('saveAction', { page: 1, type: 9, item: order.id, ignoreResponseBar: true })
    },

    // eslint-disable-next-line no-unused-vars
    repeatOrder (order) {
      //console.log('repeatOrder', order)
      this.$router.push({ name: 'orders:new', params: { repeat: order } }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
    }
  }
}
export default orders
